<script setup lang="ts">
import { t } from '@satch-ui/translations/translations'
import { localizeUrl } from '@shared/fondof-fn/url/localize'
import { useCustomerStore } from '@shared/global-store/stores/customer/customer'
import { getLogoutUrl } from '@shared/shop-api/core/oauth2'
import PopOut from '@storefront-satch/components/atoms/pop-out/PopOut.vue'

import { triggerLogoutEvent } from '@fond-of/event'
import type { CustomerInterface } from '@fond-of/spryker-api'

export interface LogoutPopOutProps {
  showBackToShop?: boolean
}

const props = defineProps<LogoutPopOutProps>()
const emits = defineEmits(['logout', 'close'])

const customerStore = useCustomerStore()

const logoutAction = async () => {
  emits('logout')
  triggerLogoutEvent({
    customer: customerStore.customer as unknown as CustomerInterface,
  })
  // in future use https://docs.astro.build/en/reference/modules/astro-transitions/#navigate for redirect
  globalThis.location.href = getLogoutUrl()
}
</script>

<template>
  <PopOut
    class="w-full shadow-lg lg:w-auto"
    @close="emits('close')"
  >
    <ul class="space-y-3.5 whitespace-nowrap px-1.5 py-2.5 pr-5 text-black">
      <li>
        <a
          class="text-base font-extrabold text-black lg:text-xs lg:font-normal"
          :href="localizeUrl('/account/wishlist')"
        >
          <div>
            {{ t('wishlist.myWishlist') }}
          </div>
        </a>
      </li>
      <li>
        <a
          class="text-base font-extrabold text-black lg:text-xs lg:font-normal"
          :href="localizeUrl('/account/orders')"
        >
          <div>
            {{ t('navigation.customer_menu.logout.my_orders') }}
          </div>
        </a>
      </li>
      <li>
        <a
          class="cursor-pointer text-base font-extrabold text-black lg:text-xs lg:font-normal"
          @click="logoutAction"
        >
          <div>
            {{ t('navigation.customer_menu.logout.logout') }}
          </div>
        </a>
      </li>
      <li>
        <a
          v-if="props.showBackToShop"
          class="!mt-8 text-base font-extrabold text-black lg:text-xs lg:font-normal"
          :href="localizeUrl('/')"
        >
          <div>
            {{ t('navigation.customer_menu.logout.backToShop') }}
          </div>
        </a>
      </li>
    </ul>
  </PopOut>
</template>
